import { RegisteredUser } from "../models/registration";

export type RegistrationStatusDisplay = {
  label: string;
  color: string;
};

export function getRegistrationStatusDisplay(
  record: RegisteredUser,
): RegistrationStatusDisplay {
  const status = (record.status || "").toLowerCase();

  if (status === "refunded") {
    return { label: "Refunded", color: "red" };
  }
  if (status === "placed") {
    return { label: "Complete", color: "green" };
  }
  if (status === "pending") {
    return { label: "Pending", color: "orange" };
  }
  if (status === "accept" || status === "accepted") {
    return { label: "Accepted", color: "green" };
  }
  if (status === "reject" || status === "rejected") {
    return { label: "Rejected", color: "red" };
  }
  if (status === "completed") {
    return { label: "Completed", color: "green" };
  }

  const orderStatus = (
    record.order as { payment_status?: string; status?: string } | undefined
  )?.payment_status?.toLowerCase();

  if (orderStatus === "refunded") {
    return { label: "Refunded", color: "red" };
  }

  return {
    label: status ? status.charAt(0).toUpperCase() + status.slice(1) : "—",
    color: "default",
  };
}

export function isRegistrationRefunded(record: RegisteredUser): boolean {
  const status = (record.status || "").toLowerCase();
  if (status === "refunded") return true;
  const orderStatus = (
    record.order as { payment_status?: string } | undefined
  )?.payment_status?.toLowerCase();
  return orderStatus === "refunded";
}
